namespace GeniuzPOS.Lookups {
    export namespace VwConceptService {
        export const baseUrl = 'Lookups/VwConcept';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwConceptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwConceptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwConcept/Retrieve",
            List = "Lookups/VwConcept/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwConceptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
